<template>
    <div class="overall-bg">
        <b-container fluid="xl">
            <b-row>
                <b-col>
                    <BacktoPage :goback="routers.back"></BacktoPage>
                    <Headerlayout :headertext="EditID
                        ? t('assetManagement.OpeningStock.edittitle')
                        : t('assetManagement.OpeningStock.title')
                        " :contenttext="t('assetManagement.OpeningStock.content')">
                    </Headerlayout>
                </b-col>
            </b-row>
            <!-- {{ isForm.ItemName }}sss -->
            <b-row class="form-white-bg my-3">
                <b-form class="" @submit.prevent="IsSubmit">
                    <b-row>
                        <b-col lg="3" md="4" sm="5" cols="12">
                            <div class="field">
                                <TextField :id="t('assetManagement.OpeningStock.code')"
                                    :name="t('assetManagement.OpeningStock.code')"
                                    :label="t('assetManagement.OpeningStock.code')" :rules="{ required: false }"
                                    v-model="isForm.AssetDisplayId" :disabled="true" placeholder=""
                                    :required-icon="false" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="3" md="4" sm="5" cols="12">
                            <div class="field" v-if="EditID == 0">
                                <label>{{ t("item.itemname") }}</label>
                                <!-- <AutoCompleteCustom v-model="isForm.SerialNumber" :items="[]" name="ItemName"
                                    id="ItemName" :optionAttrs="(item) => ({ extraValue: item.ItemQuantity })" /> -->
                                <AutoCompleteCustom v-model="isFetchData.Name" :items="commonStore.option.listAssetItem"
                                    @input="
                                        commonStore.LoadAssetItem(queryform.StoreId, queryform.BranchId, HospitalId)
                                        " class="autoItem" @item-select="ItemOnChange" name="ItemName" id="ItemName"
                                    :optionAttrs="(item) => ({ extraValue: item.ItemQuantity })" />
                            </div>

                            <div class="details-card" v-else>
                                <b-row class="px-3">
                                    <b-col sm="12" md="6" lg="10" xl="6">
                                        <b-row>
                                            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
                                                <p class="light-txt">
                                                    Item Name:</p>
                                            </b-col>
                                            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-end">
                                                <p class="fn14">{{ isFetchData.Name }}</p>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                                <b-row class="px-3">
                                    <b-col sm="12" md="6" lg="10" xl="6">
                                        <b-row>
                                            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
                                                <p class="light-txt">{{
                                                    t('assetManagement.MassConverstion.assetType') }}:</p>
                                            </b-col>
                                            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-end">
                                                <p class="fn14">{{ isFetchData.ItemCategoryName }}</p>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                                <b-row class="px-3">
                                    <b-col sm="12" md="6" lg="10" xl="6">
                                        <b-row>
                                            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
                                                <p class="light-txt">{{
                                                    t('assetManagement.MassConverstion.assetGroup') }}:</p>
                                            </b-col>
                                            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-end">
                                                <p class="fn14">{{ isFetchData.ItemGroupName }}</p>
                                            </b-col>
                                        </b-row>
                                    </b-col>

                                </b-row>
                            </div>
                            <!-- {{ isFetchData }} -->
                            <div class="field">
                                <CustomDropDownfield :label='t("assetManagement.MassConverstion.assetLifecycleStage")'
                                    v-model="isForm.AssetLifecycleStage" :items="commonStore.option.AssetLifecycleStage"
                                    :rules="{ required: false }" :required-icon="false"
                                    :id='t("assetManagement.MassConverstion.assetLifecycleStage")'
                                    :name='t("assetManagement.MassConverstion.assetLifecycleStage")' />
                            </div>
                        </b-col>
                        <b-col lg="5" md="4" sm="5" cols="12" v-if='isForm.ItemId && EditID == 0'>

                            <div class="details-card ">
                                <b-row class="px-3">
                                    <b-col sm="12" md="6" lg="10" xl="6">
                                        <b-row>
                                            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
                                                <p class="light-txt">{{
                                                    t('assetManagement.MassConverstion.assetType') }}:</p>
                                            </b-col>
                                            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-end">
                                                <p class="fn14">{{ isFetchData.ItemCategoryName }}</p>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                                <b-row class="px-3">
                                    <b-col sm="12" md="6" lg="10" xl="6">
                                        <b-row>
                                            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
                                                <p class="light-txt">{{
                                                    t('assetManagement.MassConverstion.assetGroup') }}:</p>
                                            </b-col>
                                            <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-end">
                                                <p class="fn14">{{ isFetchData.ItemGroupName }}</p>
                                            </b-col>
                                        </b-row>
                                    </b-col>

                                </b-row>
                            </div>
                        </b-col>
                    </b-row>

                    <!-- <b-row>
                        <b-col lg="3" md="4" sm="5" cols="12">
                            <div class="field">
                                <CustomDropDownfield :label='t("assetManagement.MassConverstion.assetLifecycleStage")'
                                    v-model="isForm.LocationID" :items="[]" :rules="{ required: false }"
                                    :required-icon="false" :id='t("assetManagement.MassConverstion.supplierName")'
                                    :name='t("assetManagement.MassConverstion.supplierName")' />
                            </div>
                        </b-col>
                    </b-row> -->

                    <b-row>
                        <b-col lg="10" md="12" sm="12" cols="12">
                            <b-row>
                                <b-col lg="4" md="6" sm="12">
                                    <div class="field">
                                        <TextField v-model="isForm.SerialNumber" type="text"
                                            :label="t('assetManagement.MassConverstion.serialNumber')" clearable
                                            :id="t('assetManagement.MassConverstion.serialNumber')"
                                            :name="t('assetManagement.MassConverstion.serialNumber')"
                                            :rules="{ required: false }" :required-icon="false" />
                                    </div>
                                </b-col>
                                <b-col lg="4" md="6" sm="12">
                                    <div class="field">
                                        <TextField v-model="isForm.ModelNo" type="text"
                                            :label="t('assetManagement.MassConverstion.modelno')" clearable
                                            :id="t('assetManagement.MassConverstion.modelno')"
                                            :name="t('assetManagement.MassConverstion.modelno')"
                                            :rules="{ required: false }" :required-icon="false" />
                                    </div>
                                </b-col>

                            </b-row>
                            <b-row class="mt-3">
                                <b-col lg="4" md="4" sm="4" cols="4">
                                    <div class="field">
                                        <label>{{ t('assetManagement.assetassign.trackingMechanism') }}</label>
                                        <div class="field-radiobutton mt-2" style="display: flex; gap: 10px;">
                                            <RadioButton v-model="isForm.TrackingMechanism" inputId="rfid" :value="1"
                                                :class="{ 'active-radio': isForm.TrackingMechanism === 1 }" />
                                            <label for="rfid">{{ t('assetManagement.assetassign.rfid') }}</label>
                                            <RadioButton v-model="isForm.TrackingMechanism" inputId="gps" :value="2"
                                                :class="{ 'active-radio': isForm.TrackingMechanism === 2 }" />
                                            <label for="gps">{{ t('assetManagement.assetassign.gps') }}</label>
                                            <RadioButton v-model="isForm.TrackingMechanism" inputId="bluetooth"
                                                :value="3"
                                                :class="{ 'active-radio': isForm.TrackingMechanism === 3 }" />
                                            <label for="bluetooth">{{ t('assetManagement.assetassign.bluetooth')
                                                }}</label>
                                        </div>
                                    </div>
                                </b-col>
                                <b-col lg="4" md="4" sm="12" cols="12" v-if="isForm.TrackingMechanism != 0">
                                    <div class="field">
                                        <TextField v-model="isForm.RfidTag" type="text" :label="getTrackingLabel()"
                                            clearable :id="t('assetManagement.MassConverstion.rfIdTag')"
                                            :name="t('assetManagement.MassConverstion.rfIdTag')"
                                            :rules="{ required: false }" :required-icon="false" />
                                    </div>
                                </b-col>
                            </b-row>

                            <b-row class="">
                                <b-row>
                                    <b-col>
                                        <div class="d-flex my-3">
                                            <img src="../../../../../../../../assets/Img/icons/downsymbol.svg" alt="" class="down-symbol">
                                            <h6 class="bold-heading mt6 ml-1">{{
                                                t('assetManagement.MassConverstion.purchasdetails') }}</h6>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-row>

                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col lg="10" md="12" sm="12" cols="12">
                            <b-row>
                                <b-col lg="4" md="6" sm="12">
                                    <div class="field">
                                        <!-- {{ commonStore.option.listSupplier }} -->
                                        <CustomDropDownfield :label='t("assetManagement.MassConverstion.supplierName")'
                                            v-model="isForm.SupplierName" :items="commonStore.option.listSupplier"
                                            :rules="{ required: false }" :required-icon="false"
                                            :id='t("assetManagement.MassConverstion.supplierName")'
                                            :name='t("assetManagement.MassConverstion.supplierName")' />
                                    </div>
                                </b-col>
                                <b-col lg="4" md="6" sm="12">
                                    <!-- <div class="field">
                                        <CustomDropDownfield label="Purchase No" v-model="isForm.PurchaseOrderNumber"
                                            :items="commonStore.option." :rules="{ required: false }"
                                            :required-icon="false" :id="'Asset Lifecycle Stage'"
                                            :name="'Asset Lifecycle Stage'" />
                                    </div> -->
                                    <!-- {{ commonStore.option.listPurchaseOrder }} -->
                                    <div class="field">
                                        <!-- <label>{{ $t('PurchaseOrder.ponameno') }}</label>

                                        <AutoCompleteCustom v-model="isForm.PurchaseOrderNumber" @input="
                                            commonStore.LoadPurchaseOrder(isForm.PurchaseOrderNumber, queryform.StoreIdd)
                                            " @item-select="PoOnChange" :items="commonStore.option.listPurchaseOrder"
                                            name="po" id="po" /> -->
                                        <TextField v-model="isForm.PurchaseOrderNumber" type="text"
                                            :label="t('assetManagement.MassConverstion.purchaseOrderNo')" clearable
                                            :id="t('assetManagement.MassConverstion.purchaseOrderNo')"
                                            :name="t('assetManagement.MassConverstion.purchaseOrderNo')"
                                            :rules="{ required: false }" :required-icon="false" />
                                    </div>
                                </b-col>
                                <b-col lg="4" md="4" sm="12" cols="12">
                                    <div class="field">
                                        <CustomDatepicker placeholder="" label="Purchase Date"
                                            :name="t('assetManagement.MassConverstion.purchaseddate')"
                                            :id="t('assetManagement.MassConverstion.purchaseddate')"
                                            :required-icon="false" :rules="{ required: false }"
                                            v-model="isForm.PurchaseDate" />
                                    </div>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col lg="4" md="6" sm="12">
                                    <div class="field">
                                        <CustomDropDownfield :label='t("assetManagement.MassConverstion.location")'
                                            v-model="isForm.LocationID" :items="commonStore.option.locationList"
                                            :rules="{ required: false }" :required-icon="false"
                                            :id='t("assetManagement.MassConverstion.location")'
                                            :name='t("assetManagement.MassConverstion.location")' />
                                    </div>
                                </b-col>
                                <!-- <b-col lg="4" md="6" sm="12">
                                    <div class="field">
                                        <CustomDropDownfield label="Asset Lifecycle Stage"
                                            v-model="isForm.AssetLifecycleStage" :items="[]" :rules="{ required: false }"
                                            :required-icon="false" :id="'Asset Lifecycle Stage'"
                                            :name="'Asset Lifecycle Stage'" />
                                    </div>
                                </b-col> -->
                                <b-col lg="4" md="4" sm="12" cols="12">
                                    <div class="field">
                                        <CustomDropDownfield placeholder=""
                                            :label="t('assetManagement.MassConverstion.status')"
                                            :name="t('assetManagement.MassConverstion.status')"
                                            :id="t('assetManagement.MassConverstion.status')" :required-icon="false"
                                            :items="commonStore.option.statusList" :rules="{ required: false }"
                                            v-model="isForm.StatusID" />
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>

                    <b-row class="my-3">
                        <b-col lg="12" md="12" sm="12" cols="12">
                            <div class="field">
                                <label path="Branch my-2">{{ t("assetManagement.MassConverstion.agreementType")
                                    }}</label>
                                <div>
                                    <div class="d-flex flex-wrap gap-3">
                                        <div v-for="option in checkboxOptions" :key="option.value"
                                            class="d-flex align-items-center">
                                            <Checkbox :inputId="'checkbox' + option.value"
                                                :name="'checkbox' + option.value" :value="option.value"
                                                v-model="agreementType" :disabled="isDisabled(option.value)"
                                                @change="handleChange(option.value)" />
                                            <label :for="'checkbox' + option.value" class="radio-label">{{ option.label
                                                }}</label>
                                        </div>
                                    </div>
                                    <!-- <div v-if="errorMessage" class="error-message mt-2">
                                        {{ errorMessage }}
                                    </div> -->

                                </div>

                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="10" md="12" sm="12" cols="12">
                            <!-- {{ isForm.AgreementList }} -->
                            <AgreementComponents v-model="isForm.AgreementList" />



                        </b-col>
                    </b-row>
                    <b-row>
                        <div class="d-flex flex-row-reverse">
                            <Footer type="submit" @cancel="routers.back(), IsClear()" label="Save" />
                        </div>
                    </b-row>
                </b-form>
            </b-row>
        </b-container>
    </div>

    <createdsuccessfully :visible="successpop" @ok="closetrigger()" />
    <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
    <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, reactive, computed, watch } from "vue";
import Headerlayout from "../../../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../../../components/FormComponents/BacktoMaster.vue";
import Cancel from "../../../../../../../../components/GeneralButtons/CancelButtton.vue";
import Save from "../../../../../../../../components/GeneralButtons/SaveButton.vue";
import CustomDropDownfield from "../../../../../../../../components/FormComponents/Dropdown.vue";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import TextField from "../../../../../../../../components/FormComponents/TextInput.vue";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import Footer from "../../../../../../../../components/FormComponents/Footer.vue";
import createdsuccessfully from "../../../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import common from "../../../../../../../../modules/Inventory/Service/CommonService";
import cancel from "../../../../../../../../components/GeneralButtons/CancelButtton.vue";
import Loader from "../../../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";
import CustomTextarea from "../../../../../../../../components/FormComponents/TextArea.vue";
import MastersService from "../../../../../../../../modules/Inventory/Service/MastersService";
import { checkPermission } from "../../../../../../../../modules/Inventory/Service/AccessControl";
import { useToast } from "primevue/usetoast";
import AutoCompleteCustom from "../../../../../../../../components/FormComponents/AutoComplete.vue";

import { setupHistoryManagement } from "../../../../../../../../modules/Inventory/Service/HistoryManage";
import { ScanItemModel, AgreementList } from "../../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/model/AssetInitialSetup/scanItemModel";
import AgreementComponents from "../../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/components/agreementComponents.vue"
import CustomDatepicker from "../../../../../../../../components/FormComponents/DatePicker.vue";
import axios, { AxiosResponse } from 'axios';
import { AssetItemDetailsModel } from "../../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/model/AssetInitialSetup/assetItemDetailsModel";
import ItemMasService from "../../../../../../../../modules/Inventory/Service/ItemMasService";
import AssetMasterService from "../../../../../../../../modules/Inventory/Service/AssetManagement/AssetMasterService";
import { useCommonStore } from "../../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/store/CommonStore";
interface FetchData {
    Id: number;
    Name: string;
    ItemCategoryName: string;
    ItemGroupName: string;
}
export default defineComponent({
    props: {
        selectedItem: {
            type: Object,
            Default: () => { },
        },
        showButton: {
            type: Boolean,
            Required: true,
        },
    },
    components: {
        BacktoPage,
        Headerlayout,
        Cancel,
        Save,
        CustomDatepicker,
        CustomDropDownfield,
        TextField,
        Footer,
        createdsuccessfully,
        UpdatedSuccessfully,
        Loader,
        CustomTextarea,
        AutoCompleteCustom,
        AgreementComponents
    },

    setup(props, { emit }) {

        const commonStore = useCommonStore()

        let SessionUserData = localStorage.getItem("UsersData");
        let usersData;
        if (SessionUserData !== null) {
            usersData = JSON.parse(SessionUserData);
        }

        let SessionRolesData = localStorage.getItem("RolesData");
        let rolesData;
        if (SessionRolesData !== null) {
            rolesData = JSON.parse(SessionRolesData);
        }

        let SessionEntityData = localStorage.getItem("UsersData");
        let UsersData;
        if (SessionEntityData !== null) {
            UsersData = JSON.parse(SessionEntityData);
        }


        const toast = useToast();

        let HospitalId = Number(UsersData.OrganizationId);
        // let BranchId = Number(rolesData.BranchId);
        let UserId = Number(rolesData.UserId);
        let Entitydata = ref();
        Entitydata.value = localStorage.getItem("EntityData");
        Entitydata.value = JSON.parse(Entitydata.value);
        const StatusVisible = ref(false);
        const visible = ref(false);
        const updatepop = ref(false);
        const alreadyexistpop = ref(false);
        const { t } = useI18n();
        const label = ref(t("btn.save"));
        const editItems = ref();
        const { handleSubmit, errors, resetForm, resetField } = useForm();
        let loading = ref(false);
        const routers = useRouter();

        const route = useRoute();

        const data = route.query.data as string;
        const queryform = JSON.parse(data);
        let StoreId = Number(queryform.StoreId);
        let BranchId = Number(queryform.BranchId);

        const model: any = ref(props.selectedItem);
        const EditID = queryform.Id;
        const OperationId: any = Number(queryform.OperationId);
        const successpop = ref(false);



        function closetrigger() {
            successpop.value = false;
            // updatepop.value = false;
            //routers.back();
            setupHistoryManagement(routers, 2);

        }
        const isFetchData = ref<FetchData>({
            Id: 0,
            Name: "",
            ItemCategoryName: "",
            ItemGroupName: "",

        });

        const isForm = ref<ScanItemModel>({
            IsNew: false,
            IsModified: false,
            IsDeleted: false,
            IsActive: false,
            CreatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            ModifiedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            CreatedBy: 0,
            ModifiedBy: 0,
            CreatedByName: "",
            ModifiedByName: "",
            EntityId: 0,
            EntityOperationId: 0,
            TrackingMechanism: 0,
            DeptRoleId: 0,
            HospitalId: 0,
            BranchId: 0,
            ItemName: "",
            FromStoreBranchId: queryform.BranchId,
            ToStoreBranchId: queryform.BranchId,
            IsEntitySMS: 0,
            OrganizationName: "",
            StockInId: queryform.StockTransId,
            GrnpoNumber: queryform.GrnpoNumber,
            GrnpoId: queryform.GrnpoId,
            BranchName: "",
            FromStoreBranchName: "",
            ToStoreBranchName: "",
            TaskStatus: 0,
            TaskExpiryDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            TaskName: "",
            TaskPriority: 0,
            ResponseTimeInHours: 0,
            IsApprovalRequired: false,
            LevelsOfApproval: 0,
            ModelNo: "",
            Id: 0,
            AssetDisplayId: "",
            StoreID: queryform.StoreId,
            ItemId: 0,
            CategoryId: 0,
            SubCategoryId: 0,
            AssetGroupId: 0,
            SerialNumber: "",
            AssetType: "1",
            PurchaseDate: "",
            PurchaseCost: 0,
            SupplierName: 0,
            PurchaseOrderNumber: "",
            CurrentValue: 0,
            DepreciationMethodID: 1,
            DepreciationRate: 0,
            //required
            DepreciationStartDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            MaintenanceScheduleID: 0,
            LocationID: 0,
            StatusID: 1,
            BarCode: "",
            RfidTag: "",
            AssetLifecycleStage: 0,
            UpdatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            UpdatedBy: "",
            FairMarketValue: 0.0,
            //required
            LastFMVAssessmentDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            IssueStatus: 0,
            RequestedBy: "",
            RequestId: 0,

            ToStoreId: queryform.StoreId,
            FromStoreId: queryform.StoreId,
            AgreementList: <AgreementList[]>[],
            Type: 1,
            StockInDetailId: 0,
        });

        let agreementType: any = ref([])

        let Rights = ref({
            Create: false,
            Update: false,
            Read: false,
            Delete: false,
        });
        const copyRights = JSON.parse(JSON.stringify(Rights.value));
        let ObjOperationId = ref({
            CreateId: 0,
            UpdateId: 0,
            ReadId: 0,
            DeleteId: 0,
        });
        const copyObjOperationId = JSON.parse(JSON.stringify(ObjOperationId.value));


        onMounted(() => {
            if (EditID != "" && EditID != null) {
                IsEdit();
            } else {
                GetCode();
            }
            // GetCode();
        });

        // watch(isFetchData.value.Id, (newValue) => {

        //     Object.assign(msgcontent, newValue.content);
        // });


        async function IsEdit() {
            loading.value = true;
            try {
                debugger;
                label.value = t("btn.update");;
                let response = await AssetMasterService.getfindonedata(EditID);
                const data1 = response["result"];
                LoadItemDetailsByAssetId()
                Object.keys(isForm.value).forEach((key) => {
                    if (data1[key]) isForm.value[key] = data1[key];
                });
                // alert(JSON.stringify(data1.AssetDisplayId))
                isFetchData.value.ItemCategoryName = data1.CategoryName;
                isFetchData.value.ItemGroupName = data1.GroupName;
                isFetchData.value.Name = data1.ItemName;


                loading.value = false;
            } catch (error) {
                loading.value = false;
                console.log(error);
            }
        }
        async function LoadItemDetailsByAssetId() {
            debugger;
            try {
                const response: AxiosResponse<AssetItemDetailsModel> = await AssetMasterService.getItemDetailsByAssetId(EditID);
                // alert(JSON.stringify(response["result"]['agreement'][0]))
                isForm.value.AgreementList = response["result"]['agreement'].length != 0 ? response["result"]['agreement'] : []
                // let data = response["result"]['asset'][0]
                // Object.keys(isDetailForm.value).forEach((key) => {
                //     if (data[key]) isDetailForm.value[key] = data[key];
                // });
                for (let i = 0; i < response["result"]['agreement'].length; i++) {
                    const element = response["result"]['agreement'][i];
                    agreementType.value.push(element['AgreementType'])

                }
                // alert(JSON.stringify(response["result"]['agreement'][1]['AgreementType']))

            } catch (error) {
                alert(error);
            }
        }




        async function GetCode() {
            debugger;
            let data = {
                //FormId: 1021,
                EntityId: Entitydata.value.EntityId,
                HospitalId: HospitalId,
                BranchId: BranchId,
                StoreId: StoreId
            };
            let result: any = await common.getCodeTemplate(data);
            console.log(result);
            isForm.value.AssetDisplayId = result;
        }


        // submit function

        const IsSubmit = handleSubmit(async (values) => {
            debugger;
            emit("loadershow");

            try {
                if (isForm.value.ItemId != 0) {
                    let msg = "";
                    isForm.value.CreatedAt = moment().format(
                        "YYYY-MM-DDTHH:mm:ss.SSSZ"
                    );
                    isForm.value.UpdatedAt = moment().format(
                        "YYYY-MM-DDTHH:mm:ss.SSSZ"
                    );

                    isForm.value.PurchaseDate = moment().format(
                        "YYYY-MM-DDTHH:mm:ss.SSSZ"
                    );
                    isForm.value.BranchId = queryform.BranchId;
                    isForm.value.HospitalId = usersData.HospitalId;
                    isForm.value.ModifiedBy = usersData.UserId;
                    isForm.value.CreatedBy = usersData.UserId;
                    let objinsert = Object.assign(isForm.value);
                    console.log(objinsert);
                    if (isForm.value.Id != 0) {
                        const transformedAgreementList = isForm.value.AgreementList.map((item) => {
                            return {
                                ...item, // Retain original values
                                AgreementStartDate: item.AgreementStartDate
                                    ? moment(item.AgreementStartDate, "DD/MM/YYYY").toISOString()
                                    : null,
                                Amount: Number(item.Amount),
                                MonthlyPayment: parseFloat(item.MonthlyPayment) || 0.0,
                                // TotalLeaseCost: parseFloat(item.TotalLeaseCost) || 0.0,
                                TotalLeaseCost: parseFloat(item.TotalLeaseCost) == null ? 0.0 : parseFloat(item.TotalLeaseCost),
                                PurchaseDate: item.PurchaseDate
                                    ? moment(item.PurchaseDate, "DD/MM/YYYY").toISOString()
                                    : null,
                                AgreementEndDate: item.AgreementEndDate
                                    ? moment(item.AgreementEndDate, "DD/MM/YYYY").toISOString()
                                    : null,
                            };
                        });
                        // Assign transformed list back to `isForm.value.AgreementList`
                        isForm.value.AgreementList = transformedAgreementList;
                        const data_response = await AssetMasterService.updatedata(isForm.value);
                        console.log(data_response);
                        msg = data_response["ErrorInfo"].ErrorCode;
                        emit("loaderhide");
                        // if (data_response["result"] == "Already" && msg == null) {
                        //     alreadyexistpop.value = true;
                        // } else if (msg == null) {
                        //     updatepop.value = true;
                        // }
                        if (data_response["result"] != true) {
                            updatepop.value = true
                            // await commonStore.LoadlistAssetByItemId(isFetchData.value.Id);

                        }
                    } else {
                        const data_response = await AssetMasterService.createdata(isForm.value);
                        console.log(data_response);
                        msg = data_response["ErrorInfo"].ErrorCode;
                        emit("loaderhide");
                        if (data_response["result"].length != 0) {
                            successpop.value = true
                            // await commonStore.LoadlistAssetByItemId(isFetchData.value.Id);

                        }
                    }
                } else {

                    toast.add({
                        severity: "warn",
                        summary: "You Can able to add Item",
                        detail: "",
                        life: 3000,
                    });
                }

            } catch (error) {
                emit("loaderhide");
                // alert(error);
            }
        });
        const errorMessage = ref('');
        const isNewlyLeased = ref(true); // Set this based on your asset data

        const checkboxOptions = computed(() => [
            { value: 4, label: t("assetManagement.MassConverstion.lease") },
            { value: 2, label: t("assetManagement.MassConverstion.insurance") },
            { value: 1, label: t("assetManagement.MassConverstion.amc") },
            { value: 3, label: t("assetManagement.MassConverstion.warranty") },

            //          case 1: return 'amc';
            // case 2: return 'insurance';
            // case 3: return 'warranty';
            // case 4: return 'lease';
        ]);

        const isDisabled = (value) => {
            // If already 2 selections and current value not included, disable
            if (agreementType.value.length >= 2 && !agreementType.value.includes(value))
                return true;

            // AMC (1) and Warranty (3) cannot be selected together
            if (value === 1 && agreementType.value.includes(3)) return true; // Disable AMC if Warranty is selected
            if (value === 3 && agreementType.value.includes(1)) return true; // Disable Warranty if AMC is selected

            // AMC (1) and Lease (4) cannot be selected together
            if (value === 1 && agreementType.value.includes(4)) return true; // Disable AMC if Lease is selected
            if (value === 4 && agreementType.value.includes(1)) return true; // Disable Lease if AMC is selected

            return false;
        };
        const updateAgreementList = () => {
            isForm.value.AgreementList = agreementType.value.map((type) => ({
                IsNew: true,
                IsModified: true,
                IsDeleted: false,
                IsActive: true,
                CreatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                ModifiedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                CreatedBy: 0,
                ModifiedBy: 0,
                CreatedByName: "",
                ModifiedByName: "",
                EntityId: 0,
                EntityOperationId: 0,
                DeptRoleId: 0,
                HospitalId: 0,
                BranchId: 0,
                FromStoreBranchId: 0,
                ToStoreBranchId: 0,
                IsEntitySMS: 0,
                OrganizationName: "",
                BranchName: "",
                FromStoreBranchName: "",
                ToStoreBranchName: "",
                TaskStatus: 0,
                TaskExpiryDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                TaskName: "",
                TaskPriority: 0,
                ResponseTimeInHours: 0,
                IsApprovalRequired: true,
                LevelsOfApproval: 0,
                Id: 0,
                AssetID: 0,
                AgreementType: type,
                Provider: ref(),
                PurchaseDate: "",

                AgreementStartDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                AgreementEndDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                AgreementStatus: "1",
                BuyoutOption: "",
                CoverageType: "",
                PolicyNumber: "",
                Amount: 0,
                Premium: "",
                RenewalTerms: "",
                CoverageDetails: "",
                PaymentSchedule: "",
                Notes: "",
                UpdatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                UpdatedBy: "",
                WarrantyStatus: "",
                OutstandingPayments: 0,
                ExpiryReason: "",
                PreviousAgreementID: 0,
                MonthlyPayment: 0.0,
                TotalLeaseCost: 0.0,
                LessorName: "",
                TerminationDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                TerminationReason: "",
                Code: "",
                Barcode: "",
                BarcodeNumber: 0

            }));
            //   alert(JSON.stringify(isForm.value.AgreementList))


        };


        const handleChange = (changedValue) => {
            errorMessage.value = '';

            // Limit to two selections
            if (agreementType.value.length > 2) {
                agreementType.value = agreementType.value.filter(v => v === changedValue || v === agreementType.value[agreementType.value.length - 2]);
            }

            // Warranty and AMC rule
            if (agreementType.value.includes(3) && agreementType.value.includes(4)) {
                if (changedValue === 3) {
                    agreementType.value = agreementType.value.filter(v => v !== 4);
                } else {
                    agreementType.value = agreementType.value.filter(v => v !== 3);
                }
                errorMessage.value = "Warranty is active. AMC can only be applied after the warranty expires.";
            }

            // Warranty and Lease rule
            if (agreementType.value.includes(1) && agreementType.value.includes(4) && !isNewlyLeased.value) {
                errorMessage.value = "Leased asset cannot have a warranty if it is not newly purchased.";
            }

            // Combination rule
            if (agreementType.value.includes(3) && agreementType.value.includes(4)) {
                errorMessage.value = "AMC cannot be applied while the asset is under Warranty.";
            }
            updateAgreementList();
        };


        const getTrackingLabel = () => {
            switch (isForm.value.TrackingMechanism) {
                case 1:
                    return 'RFID Tag';
                case 2:
                    return 'GPS ID';
                case 3:
                    return 'Bluetooth ID';
                default:
                    return 'Tag ID';
            }
        };


        const IsClear = () => {


            emit("update:selectedItem", undefined);
            emit("close");
        };


        const isCreate = () => {
            StatusVisible.value = true;
        };
        async function FunctionRights(EntityId, FieldType) {
            debugger;
            Object.assign(Rights.value, copyRights);
            Object.assign(ObjOperationId.value, copyObjOperationId);
            const response = await MastersService.CheckMenuRights(
                EntityId,
                rolesData.RoleId
            );
            console.log(response["result"]);

            for (let i = 0; i < response["result"].length; i++) {
                const operation = response["result"][i];
                if (operation.OperationName === "Create") {
                    ObjOperationId.value.CreateId = operation.OperationID;
                    Rights.value.Create = operation.IsActive;
                } else if (operation.OperationName === "Update") {
                    ObjOperationId.value.UpdateId = operation.OperationID;
                    Rights.value.Update = operation.IsActive;
                } else if (operation.OperationName === "Read") {
                    ObjOperationId.value.ReadId = operation.OperationID;
                    Rights.value.Read = operation.IsActive;
                } else if (operation.OperationName === "Delete") {
                    ObjOperationId.value.DeleteId = operation.OperationID;
                    Rights.value.Delete = operation.IsActive;
                }
            }
            let permissionResult: any = checkPermission(Rights, "Add");
            if (permissionResult.hasPermission) {
                // DialogShow.value[FieldType] = true;
            } else {
                toast.add(permissionResult.toast);
                return;
            }
        }

        const ItemOnChange = async (Itemdata) => {
            debugger;
            if (Itemdata) {
                isForm.value.ItemId = Itemdata.value.Id;
                isForm.value.CategoryId = Itemdata.value.ItemCategoryId
                isForm.value.SubCategoryId = Itemdata.value.SubGroupId
                isForm.value.AssetGroupId = Itemdata.value.ItemGroupId
                isForm.value.EntityId = Entitydata.value.EntityId,
                    // alert(JSON.stringify(isForm.value.EntityId))
                    isFetchData.value.ItemCategoryName = Itemdata.value.ItemCategoryName;
                isFetchData.value.ItemGroupName = Itemdata.value.ItemGroupName;
            }

        };
        const PoOnChange = async (podata) => {
            debugger;
            if (podata) {
                isForm.value.PurchaseOrderNumber = podata.value.DocNo;
            }
        };

        onMounted(async () => {
            try {
                await Promise.all([
                    commonStore.LoadSupplier(),
                    commonStore.LoadStatus(),
                    commonStore.Loadlocation(),
                ]);
            } catch (error) {
                console.error('Error in onMounted:', error);
            } finally {
            }
        });
        return {
            getTrackingLabel,
            successpop,
            PoOnChange,
            checkboxOptions,
            isDisabled,
            handleChange,
            isFetchData,
            HospitalId,
            queryform,
            ItemOnChange,
            agreementType,
            commonStore,
            t,
            routers,
            IsSubmit,
            EditID,
            ObjOperationId,
            FunctionRights,
            isCreate,
            editItems,
            StatusVisible,
            alreadyexistpop,
            isForm,
            loading,
            visible,
            updatepop,
            closetrigger,
            IsEdit,
            IsClear,



        };
    },
});
</script>
